module.exports = __webpack_public_path__ + "static/img/4012.834a1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4012.png
// module id = 719
// module chunks = 0 1 12